import React from 'react';
import {LoginBranding} from '@components/login/LoginBranding';
import {Coach360Login} from '@components/login/Coach360Login';
import 'styles/LoginPage.styl';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';

@connectToStores
class LoginPage extends React.PureComponent<ReturnType<typeof LoginPage.getPropsFromStores>> {
  static getStores() {
    return [AuthStore];
  }

  static getPropsFromStores() {
    const loadingAuth = AuthStore.getState().loadingAuth;
    return {loadingAuth};
  }

  render() {
    return (
      <div className="login-page">
        <LoginBranding />
        <div className="sidebar">
          <Coach360Login loadingAuth={this.props.loadingAuth} />
        </div>
      </div>
    );
  }
}

export default LoginPage as unknown as React.FC;
